import type { Flow } from '../../../modules/Auth0/types';
import { captchaEvent } from '../../../modules/metrics';

import { logError } from './utils';

const getCaptchaToken = async (
  flow: Flow,
  googleCaptchaSiteKey: string,
  attempt: number = 1,
): Promise<string | undefined> =>
  new Promise((resolve) => {
    try {
      const { grecaptcha: { enterprise: enterpriseRecaptcha } = {} } = window;
      if (!enterpriseRecaptcha) {
        captchaEvent('recaptcha_library_not_loaded');
        return resolve(undefined);
      }
      enterpriseRecaptcha.ready(() => {
        try {
          const token = enterpriseRecaptcha.getResponse();
          captchaEvent('recaptcha_fetched');
          return resolve(token);
        } catch {
          logError(
            new Error('Recaptcha token retrieval failure'),
            'recaptcha_loaded_but_token_retrieve_failed',
          );
          return attempt === 1
            ? resolve(getCaptchaToken(flow, googleCaptchaSiteKey, attempt + 1))
            : resolve(undefined);
        }
      });
    } catch {
      logError(
        new Error('Error fetching recaptcha'),
        'error_fetching_recaptcha',
      ); // first argument with type Error
      return resolve(undefined);
    }
  });

export default getCaptchaToken;
